import './FundObjective.css';

export interface FundObjectiveProps {
  content: string;
}

const FundObjective = ({ content }: FundObjectiveProps): JSX.Element => {
  return (
    <div className="fund-objective">
      <div className="fund-objective__subheader">
        <span className="fund-objective__label">Objective</span>
      </div>
      <p className="fund-objective__content">{content}</p>
    </div>
  );
};

export default FundObjective;
